import { joinIds } from "./component-model";

export interface FieldControlProps {
  readonly id: string;
  readonly required?: true;
  readonly "aria-describedby"?: string;
  readonly "aria-invalid"?: true;
  readonly "aria-errormessage"?: string;
}

export interface FieldMetadata {
  readonly controlId: string;
  readonly hintId: string;
  readonly errorId: string;
  readonly controlProps: FieldControlProps;
}

export function buildFieldMetadata(
  controlId: string,
  {
    hasHint,
    hasError,
    required,
  }: {
    readonly hasHint: boolean;
    readonly hasError: boolean;
    readonly required: boolean;
  },
): FieldMetadata {
  const hintId = `${controlId}-hint`;
  const errorId = `${controlId}-error`;
  const describedBy = joinIds(
    hasHint ? hintId : undefined,
    hasError ? errorId : undefined,
  );

  return {
    controlId,
    hintId,
    errorId,
    controlProps: {
      id: controlId,
      ...(required ? { required: true as const } : {}),
      ...(describedBy ? { "aria-describedby": describedBy } : {}),
      ...(hasError
        ? {
            "aria-invalid": true as const,
            "aria-errormessage": errorId,
          }
        : {}),
    },
  };
}
